import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import PropTypes from 'prop-types';
import {Button, Form} from 'semantic-ui-react';
import FormInput from '../shared/forms/input';
import {fetchCode} from '../../redux/actions/code';

function Code(props) {
  const {handleSubmit, pristine, submitting, error} = props;

  async function submit(values) {
    try {
      const {payload: code} = await props.fetchCode(values.text);
      props.setCode(code);
    } catch (error) {
      const errorMessage = error.data.detail;
      throw new SubmissionError({text: errorMessage});
    }
  }

  async function reset() {
    props.reset();
    props.setCode(null);
  }

  if (!!props.code) {
    return (
      <Button
        compact
        size='tiny'
        negative
        content={`حذف کد تخفیف ثبت شده`}
        onClick={reset}
      />
    );
  }
  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Field
        error={error}
        size='mini'
        name='text'
        label='کد تخفیف'
        component={FormInput}
      />
      <Button
        positive
        type='submit'
        size='tiny'
        disabled={pristine || submitting}
        content='ثبت کد تخفیف'
      />
    </Form>
  );
}

Code.propTypes = {
  fetchCode: PropTypes.func.isRequired
};

export default compose(
  connect(null, {fetchCode}),
  reduxForm({form: 'code'})
)(Code);
